module.exports = {"TXTWCL_Your_voucher_amount":{"id":"TXTWCL_Your_voucher_amount","defaultMessage":"Your voucher amount","track":"Your voucher amount"}}